import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './_services/index';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'Invenire';
  username: string;
  loggedIn : false;

  constructor(public AuthService : AuthService, private cdRef:ChangeDetectorRef) { }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

}
